import React from "react";

function Events() {
  return (
    <div>
      <div class='container-lg mt-5'>
        <div class='row d-flex align-items-center justify-content-center'>
          <div class='col-sm-10 col-lg-5'>
            <div class='card '>
              <div class='card-body p-5'>
                <h5 class='text-black'>How to do it in reactJS ?</h5>

                <p class='text-black-50'>
                  24-04-2021 |{" "}
                  <span class='text-danger fs-6'> Project based Learning</span>
                </p>
                <p class='text-black pt-2'>
                  In this Event we will be doing the development of your choice.
                </p>
                <p class='text-black-50 pt-2 fs-6'>
                  On the day of event you'll be able to join it using the button
                  below.
                </p>
                <button class='btn btn-link' disabled>
                  Join Class
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Events;
